import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

/** Lines its children up in a row with a 24px gap. */
export const HStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("flex gap-6", className)} {...props}>
        {children}
      </div>
    );
  }
);

HStack.displayName = "HStack";
